import stateClasses from '../data/stateClasses';

export default class Toaster {

	constructor(el) {
		this.el = el;
		this.toasterText = el.querySelector('.js-toaster-text');
	}

	show(message = '') {
		this.toasterText.innerText = message;
		this.el.classList.add(stateClasses.isActive);

		setTimeout(() => {
			this.el.classList.remove(stateClasses.isActive);
		}, 3000);
	}
};